import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Button } from '../../components/ui/button';
import { toast } from 'sonner';
import { FileText, Package, Image, Award, LogOut } from 'lucide-react';

const AdminDashboard = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) {
      navigate('/admin/login');
    }
  }, [user, navigate]);

  const handleLogout = () => {
    logout();
    toast.success('已登出');
    navigate('/admin/login');
  };

  const menuItems = [
    {
      title: 'Blog 管理',
      desc: '管理最新資訊和文章',
      icon: <FileText className="w-8 h-8" />,
      link: '/admin/blog',
      color: 'from-blue-400 to-cyan-400'
    },
    {
      title: '產品管理',
      desc: '管理產品目錄',
      icon: <Package className="w-8 h-8" />,
      link: '/admin/products',
      color: 'from-green-400 to-teal-400'
    },
    {
      title: '圖片管理',
      desc: '上傳和管理圖片',
      icon: <Image className="w-8 h-8" />,
      link: '/admin/images',
      color: 'from-purple-400 to-pink-400'
    }
  ];

  if (!user) return null;

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100" data-testid="admin-dashboard">
      <header className="bg-white shadow-sm">
        <div className="container mx-auto px-6 py-4 flex items-center justify-between">
          <h1 className="text-2xl font-bold gradient-text">樹記海鮮 CMS</h1>
          <div className="flex items-center gap-4">
            <span className="text-slate-600">歡迎，{user.username}</span>
            <Button
              onClick={handleLogout}
              variant="outline"
              className="rounded-full"
              data-testid="logout-btn"
            >
              <LogOut className="w-4 h-4 mr-2" />
              登出
            </Button>
          </div>
        </div>
      </header>

      <main className="container mx-auto px-6 py-12">
        <div className="mb-12">
          <h2 className="text-4xl font-bold mb-4">管理中心</h2>
          <p className="text-slate-600 text-lg">管理您的網站內容</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {menuItems.map((item, index) => (
            <Link key={index} to={item.link}>
              <div className="glass p-8 rounded-3xl hover:shadow-2xl transition-all duration-300 hover:-translate-y-2" data-testid={`menu-item-${index}`}>
                <div className={`w-16 h-16 bg-gradient-to-br ${item.color} rounded-2xl flex items-center justify-center text-white mb-6`}>
                  {item.icon}
                </div>
                <h3 className="text-2xl font-bold mb-2">{item.title}</h3>
                <p className="text-slate-600">{item.desc}</p>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-12 glass p-8 rounded-3xl">
          <h3 className="text-2xl font-bold mb-4">快速連結</h3>
          <div className="flex gap-4">
            <Link to="/">
              <Button variant="outline" className="rounded-full">
                查看網站
              </Button>
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
};

export default AdminDashboard;